import { Link } from "react-router-dom";
import styled from "styled-components";

export const Card = styled(Link)<{ $direction: "row" | "column" }>`
  box-sizing: border-box;
  isolation: isolate;
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  width: 100%;
  min-height: 500px;
  max-height: 520px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  color: ${({ theme }) => theme.colors.darkBlue};
  text-decoration: none;
  cursor: pointer;
  transition: box-shadow 0.4s ease, border 0.5s ease-in-out,
    color 0.5s ease-in-out, opacity 0.5s ease-in-out;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 4px;
  }

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.cardHover};

    button {
      border: ${({ theme }) => `1.5px solid ${theme.colors.accent}`};
      color: ${({ theme }) => theme.colors.accent};
    }

    h3 {
      color: ${({ theme }) => theme.colors.accent};
    }
    p {
      opacity: 1;
    }
  }

  @media (max-width: 1280px) {
    min-height: 42dvw;
    max-height: 56dvw;
  }

  @media (max-width: 1024px) {
    flex-direction: row;
    min-height: 24dvw;
    max-height: 28dvw;
    height: 26dvw;
  }

  @media (max-width: 900px) {
    min-height: 32dvw;
    max-height: 36dvw;
    height: 34dvw;
  }

  @media (max-width: 800px) {
    height: 40dvw;
    max-height: 58dvw;
  }

  @media (max-width: 720px) {
    flex-direction: ${({ $direction }) => $direction};
    min-height: ${({ $direction }) =>
      $direction === "row" ? "44dvw" : "max-content"};
    height: ${({ $direction }) =>
      $direction === "row" ? "44dvw" : "max-content"};
  }

  @media (max-width: 620px) {
    min-height: ${({ $direction }) =>
      $direction === "row" ? "48dvw" : "max-content"};
    height: ${({ $direction }) =>
      $direction === "row" ? "48dvw" : "max-content"};
  }

  @media (max-width: 590px) {
    min-height: 400px;
    height: max-content;
    max-height: 100%;
  }

  @media (max-width: 340px) {
    flex-direction: column;
  }

  @media (min-width: 2500px) {
    min-height: 26dvw;
    max-height: 38dvw;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  @media (min-width: 3400px) {
    min-height: 30dvw;
    max-height: 46dvw;
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }

  @media (min-width: 4500px) {
    border-radius: 52px;
    min-height: 32dvw;
    max-height: 52dvw;
  }
`;

export const ImageContainer = styled.div<{
  $direction: "row" | "column";
}>`
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  background-color: ${({ $direction }) =>
    $direction === "row" ? "#f4f7fa" : "transparent"};

  @media (max-width: 340px) {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  @media (min-width: 2500px) {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 4500px) {
    border-radius: 52px;
  }
`;

export const CardImage = styled.img<{
  $imageFit: "cover" | "contain";
  $direction: "row" | "column";
}>`
  box-sizing: border-box;
  width: ${({ $direction }) => ($direction === "row" ? "12rem" : "100%")};
  min-width: ${({ $direction }) => ($direction === "row" ? "12rem" : "0")};
  min-height: 16rem;
  height: ${({ $direction }) => ($direction === "row" ? "100%" : "16rem")};
  padding: ${({ $direction }) => ($direction === "row" ? "20px 12px" : "0")};
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  object-fit: ${({ $imageFit }) => $imageFit};
  object-position: center;
  background-color: #f4f7fa;

  @media (max-width: 1860px) {
    width: ${({ $direction }) => ($direction === "row" ? "10rem" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "10rem" : "0")};
  }

  @media (max-width: 1720px) {
    width: ${({ $direction }) => ($direction === "row" ? "8rem" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "8rem" : "0")};
  }

  @media (max-width: 1600px) {
    width: ${({ $direction }) => ($direction === "row" ? "12rem" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "12rem" : "0")};
  }

  @media (max-width: 1410px) {
    width: ${({ $direction }) => ($direction === "row" ? "12dvw" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "12dvw" : "0")};
  }

  @media (max-width: 1280px) {
    min-height: 20rem;
    height: ${({ $direction }) => ($direction === "row" ? "100%" : "20rem")};
    width: ${({ $direction }) => ($direction === "row" ? "16rem" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "16rem" : "0")};
  }

  @media (max-width: 1024px) {
    min-height: 100%;
    height: 100%;
    width: 42dvw;
    min-width: 42dvw;
  }

  @media (max-width: 900px) {
    width: 44dvw;
    min-width: 44dvw;
  }

  @media (max-width: 720px) {
    min-height: 14rem;
    height: ${({ $direction }) => ($direction === "row" ? "100%" : "14rem")};
    width: ${({ $direction }) => ($direction === "row" ? "30dvw" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "30dvw" : "0")};
    object-position: ${({ $direction }) =>
      $direction === "row" ? "center" : "top"};
  }

  @media (max-width: 590px) {
    max-height: 20rem;
    min-height: ${({ $direction }) =>
      $direction === "row" ? "14rem" : "20rem"};
    height: 20rem;
  }

  @media (max-width: 455px) {
    min-height: ${({ $direction }) =>
      $direction === "row" ? "100%" : "14rem"};
    height: ${({ $direction }) => ($direction === "row" ? "100%" : "14rem")};
    max-height: ${({ $direction }) =>
      $direction === "row" ? "100%" : "14rem"};

    img {
      height: 100%;
    }
  }

  @media (min-width: 2500px) {
    min-height: 12dvw;
    height: ${({ $direction }) => ($direction === "row" ? "100%" : "12dvw")};
    width: ${({ $direction }) => ($direction === "row" ? "8dvw" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "8dvw" : "0")};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  @media (min-width: 3400px) {
    padding: ${({ $direction, theme }) =>
      $direction === "row" ? theme.padding.regular : "0"};
    min-height: 14dvw;
    height: ${({ $direction }) => ($direction === "row" ? "100%" : "14dvw")};
    width: ${({ $direction }) => ($direction === "row" ? "9dvw" : "100%")};
    min-width: ${({ $direction }) => ($direction === "row" ? "9dvw" : "0")};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }

  @media (min-width: 3800px) {
    padding: ${({ $direction, theme }) =>
      $direction === "row" ? theme.padding.medium : "0"};
  }

  @media (min-width: 4500px) {
    border-radius: 52px;
  }
`;

export const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  padding: ${({ theme }) => theme.padding.regular};
  height: 100%;

  h3,
  p {
    margin: 0;
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight.extrabold};
    line-height: 1.2;
    text-transform: uppercase;
    white-space: pre-line;
  }

  p {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    line-height: 1.35;
    white-space: pre-line;
    color: ${({ theme }) => theme.colors.darkBlue};
    opacity: 0.7;
  }

  @media (max-width: 720px) {
    height: auto;
  }

  @media (max-width: 520px) {
    h3 {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
  }

  @media (min-width: 2500px) {
    h3 {
      font-size: 1.75rem;
    }
    p {
      font-size: 1.5rem;
    }
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium};

    h3 {
      font-size: 2rem;
    }
    p {
      font-size: 1.75rem;
    }
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.padding.large};
    gap: ${({ theme }) => theme.spacing.medium};

    h3 {
      font-size: 2.5rem;
    }
    p {
      font-size: 2.25rem;
    }
  }
  @media (min-width: 3800px) {
    h3 {
      font-size: 2.75rem;
    }
    p {
      font-size: 2.575rem;
    }
  }
  @media (min-width: 4500px) {
    padding: 52px;
    gap: 52px;

    h3 {
      font-size: 3.25rem;
    }
    p {
      font-size: 3rem;
    }
  }
  @media (min-width: 5000px) {
    h3 {
      font-size: 3.75rem;
    }
    p {
      font-size: 3.5rem;
    }
  }
`;

export const ButtonContainer = styled.div<{
  $direction: "row" | "column";
}>`
  margin-top: auto;
  align-self: flex-end;
  justify-self: end;
`;

export const Button = styled.button`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  display: inline-flex;
  width: max-content;
  inline-size: max-content;
  max-width: 100%;
  flex: 0 0 auto;
  align-items: stretch;
  justify-content: center;
  gap: 0;
  padding: 10px 20px;
  border: ${({ theme }) => `1.5px solid ${theme.colors.darkBlue}`};
  border-radius: 999px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.darkBlue};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;
  transition: box-shadow 3s cubic-bezier(0.16, 1, 0.3, 1),
    border 0.55s ease-in-out, color 0.55s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    background-color: ${({ theme }) => theme.colors.accent};

    opacity: 0.14;
    transform: translateY(101%);
    transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
  }

  &:hover::before,
  &:hover > span::before {
    transform: translateY(0);
  }

  &:hover {
    border: ${({ theme }) => `1.5px solid ${theme.colors.accent}`};
    color: ${({ theme }) => theme.colors.accent};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible:not(:disabled) {
    outline: 1.5px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 2px;
  }

  &:active:not(:disabled) {
    box-shadow: ${({ theme }) => theme.shadow.buttonActive};
    transition-duration: 0.08s;
  }

  &:active:not(:disabled) > span {
    box-shadow: none;
    transition-duration: 0.08s;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    &::before,
    & > span::before {
      transition-duration: 0.01ms;
    }
  }

  @media (min-width: 2500px) {
    font-size: 1.5rem;
  }
  @media (min-width: 3000px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
    padding: 14px 28px;
    border: ${({ theme }) => `2px solid ${theme.colors.darkBlue}`};
  }
  @media (min-width: 3800px) {
    font-size: 2.575rem;
  }
  @media (min-width: 4500px) {
    font-size: 3rem;
    padding: 1.5rem 3.5rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.5rem;
  }
`;
